import { Grid, MenuItem, TextField } from '@mui/material';
import { useDashboardStatsContext } from '../../../context/use-dashboard-stats.context';
import { MedianTimeInLockerState } from '../../../hooks/useMedianTimeInLocker';
import { DashboardCardTitle } from '../../dashboard-card-title/dashboard-card-title.component';

export function TimeInLockerHeader() {
  const { medianTimeInLocker } = useDashboardStatsContext();

  return (
    <Grid
      container
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <Grid>
        <DashboardCardTitle title="Storage Duration" />
      </Grid>
      <Grid>
        <TextField
          variant="outlined"
          select
          size="small"
          value={medianTimeInLocker.state.completedEventType}
          onChange={(e) =>
            medianTimeInLocker.handlers.onChangeEventType(
              e.target.value as MedianTimeInLockerState['completedEventType']
            )
          }
        >
          {completedEventTypeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}

const availableCompletedEventTypes: Record<MedianTimeInLockerState['completedEventType'], string> = {
  collected: 'Collected',
  retrieved: 'Retrieved',
  completed: 'Both'
};

const completedEventTypeOptions = (Object.entries as <T>(object: T) => [keyof T, T[keyof T]][])(
  availableCompletedEventTypes
).map(([value, label]) => ({
  value,
  label
}));
